<template>
    <div>
        <div class="background">
            <img :src="imgSrc" width="100%" height="100%" alt="" />
        </div>
        <div class="front">
            <div class="errorTitle">机器故障,暂停使用</div>
            <br />
            <br />
            <br />
            <div class="errorReason">故障原因：{{ sharedState.errorMessage }}</div>
        </div>
    </div>
</template>

<script>

export default {
    name: "errorPage",
    data() {
        return {
            imgSrc: require('@/assets/images/errorbg.jpg'),
            sharedState: this.myStore.state
        }
    },
    methods: {
        
    }
}
</script>

<style scoped>
.background {
    width: 100%;  
    height: 100%;  /**宽高100%是为了图片铺满屏幕 */
    z-index: -1;
    position: absolute;
}

.front {
    width: 70%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    color: red;
    text-align: center;
}

.errorTitle {
    font-size: 5rem;
}

.errorReason {
    font-size: 3rem;
}
</style>